import { render } from "./eretailer.vue?vue&type=template&id=cedb00b8"
import script from "./eretailer.vue?vue&type=script&lang=js"
export * from "./eretailer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__